// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconButton_icon-button-container__button__XT\\+DD {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  width: 32px;
  height: 32px;
}
.IconButton_icon-button-container__button__XT\\+DD > * {
  font-size: 20px;
  color: var(--m-icon-color);
}
.IconButton_icon-button-container__button--icon__0c7ev {
  display: flex;
}
.IconButton_icon-button-container__button--circle__PxE73 {
  border-radius: 50%;
}
.IconButton_icon-button-container__button--default__sHrPv {
  background-color: #f1f2f4;
}
.IconButton_icon-button-container__button--default__sHrPv:hover {
  background-color: var(--m-subtle);
}
.IconButton_icon-button-container__button--default__sHrPv:active {
  background-color: var(--m-subtle-bolder);
}
.IconButton_icon-button-container__button--subtle__RZ\\+eA {
  background-color: transparent;
}
.IconButton_icon-button-container__button--subtle__RZ\\+eA:hover {
  background-color: #f1f2f4;
}
.IconButton_icon-button-container__button--subtle__RZ\\+eA:active {
  background-color: var(--m-subtle-bolder);
}
.IconButton_icon-button-container__button--primary__J6Upd {
  background-color: var(--m-primary);
  color: var(--m-white);
}
.IconButton_icon-button-container__button--primary__J6Upd:hover {
  background-color: var(--m-background-primary-hovered);
}
.IconButton_icon-button-container__button--primary__J6Upd:active {
  background-color: var(--m-background-primary-pressed);
}
.IconButton_icon-button-container__button--primary-subtle__eN8za {
  background-color: var(--m-background-subtle-primary, var(--m-primary-subtle));
}
.IconButton_icon-button-container__button--primary-subtle__eN8za > * {
  color: #00b4f3;
}
.IconButton_icon-button-container__button--primary-subtle__eN8za:hover {
  background-color: var(--m-background-subtle-primary-hovered, var(--m-primary-subtle-hovered));
}
.IconButton_icon-button-container__button--primary-subtle__eN8za:active {
  background-color: var(--m-background-subtle-primary-pressed, var(--m-primary-subtle-pressed));
}
.IconButton_icon-button-container__button--warning__2gcKO {
  background-color: var(--m-warning);
  color: var(--m-text);
}
.IconButton_icon-button-container__button--warning__2gcKO:hover {
  background-color: var(--m-background-warning-hovered);
}
.IconButton_icon-button-container__button--warning__2gcKO:active {
  background-color: var(--m-background-warning-pressed);
}
.IconButton_icon-button-container__button--danger__v-yIO {
  background-color: var(--m-danger);
  color: var(--m-white);
}
.IconButton_icon-button-container__button--danger__v-yIO:hover {
  background-color: var(--m-background-danger-hovered);
}
.IconButton_icon-button-container__button--danger__v-yIO:active {
  background-color: var(--m-background-danger-pressed);
}
.IconButton_icon-button-container__button--medium__gMj6d {
  width: 36px;
  height: 36px;
}
.IconButton_icon-button-container__button__XT\\+DD:disabled {
  pointer-events: none;
  background-color: #f7f8f9;
}
.IconButton_icon-button-container__button__XT\\+DD:disabled * {
  color: #adb4c0;
}

[m-data-theme=dark] .IconButton_icon-button-container__button--default__sHrPv:hover, [m-data-theme=dark] .IconButton_icon-button-container__button--subtle__RZ\\+eA:hover, [m-data-theme=dark] .IconButton_icon-button-container__button--primary__J6Upd:hover, [m-data-theme=dark] .IconButton_icon-button-container__button--primary-subtle__eN8za:hover, [m-data-theme=dark] .IconButton_icon-button-container__button--warning__2gcKO:hover, [m-data-theme=dark] .IconButton_icon-button-container__button--danger__v-yIO:hover {
  background-color: var(--m-subtle-card-background-color);
}
[m-data-theme=dark] .IconButton_icon-button-container__button--default__sHrPv:active, [m-data-theme=dark] .IconButton_icon-button-container__button--subtle__RZ\\+eA:active, [m-data-theme=dark] .IconButton_icon-button-container__button--primary__J6Upd:active, [m-data-theme=dark] .IconButton_icon-button-container__button--primary-subtle__eN8za:active, [m-data-theme=dark] .IconButton_icon-button-container__button--warning__2gcKO:active, [m-data-theme=dark] .IconButton_icon-button-container__button--danger__v-yIO:active {
  background-color: var(--m-subtle-card-background-color);
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Button/IconButton/IconButton.module.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAAJ;AAEI;EACE,eAAA;EACA,0BAAA;AAAN;AAGI;EACE,aAAA;AADN;AAII;EACE,kBAAA;AAFN;AAKI;EACE,yBAAA;AAHN;AAKM;EACE,iCAAA;AAHR;AAMM;EACE,wCAAA;AAJR;AAQI;EACE,6BAAA;AANN;AAQM;EACE,yBAAA;AANR;AASM;EACE,wCAAA;AAPR;AAWI;EACE,kCAAA;EACA,qBAAA;AATN;AAWM;EACE,qDAAA;AATR;AAYM;EACE,qDAAA;AAVR;AAcI;EACE,6EAAA;AAZN;AAiBM;EACE,cAAA;AAfR;AAkBM;EACE,6FAAA;AAhBR;AAsBM;EACE,6FAAA;AApBR;AA2BI;EACE,kCAAA;EACA,oBAAA;AAzBN;AA2BM;EACE,qDAAA;AAzBR;AA4BM;EACE,qDAAA;AA1BR;AA8BI;EACE,iCAAA;EACA,qBAAA;AA5BN;AA8BM;EACE,oDAAA;AA5BR;AA+BM;EACE,oDAAA;AA7BR;AAiCI;EACE,WAAA;EACA,YAAA;AA/BN;AAkCI;EACE,oBAAA;EACA,yBAAA;AAhCN;AAkCM;EACE,cAAA;AAhCR;;AA+CQ;EACE,uDAAA;AA5CV;AA+CQ;EACE,uDAAA;AA7CV","sourcesContent":[".icon-button-container {\n  &__button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border: none;\n    width: 32px;\n    height: 32px;\n\n    > * {\n      font-size: 20px;\n      color: var(--m-icon-color);\n    }\n\n    &--icon {\n      display: flex;\n    }\n\n    &--circle {\n      border-radius: 50%;\n    }\n\n    &--default {\n      background-color: #f1f2f4;\n\n      &:hover {\n        background-color: var(--m-subtle);\n      }\n\n      &:active {\n        background-color: var(--m-subtle-bolder);\n      }\n    }\n\n    &--subtle {\n      background-color: transparent;\n\n      &:hover {\n        background-color: #f1f2f4;\n      }\n\n      &:active {\n        background-color: var(--m-subtle-bolder);\n      }\n    }\n\n    &--primary {\n      background-color: var(--m-primary);\n      color: var(--m-white);\n\n      &:hover {\n        background-color: var(--m-background-primary-hovered);\n      }\n\n      &:active {\n        background-color: var(--m-background-primary-pressed);\n      }\n    }\n\n    &--primary-subtle {\n      background-color: var(\n        --m-background-subtle-primary,\n        var(--m-primary-subtle)\n      );\n\n      > * {\n        color: #00b4f3;\n      }\n\n      &:hover {\n        background-color: var(\n          --m-background-subtle-primary-hovered,\n          var(--m-primary-subtle-hovered)\n        );\n      }\n\n      &:active {\n        background-color: var(\n          --m-background-subtle-primary-pressed,\n          var(--m-primary-subtle-pressed)\n        );\n      }\n    }\n\n    &--warning {\n      background-color: var(--m-warning);\n      color: var(--m-text);\n\n      &:hover {\n        background-color: var(--m-background-warning-hovered);\n      }\n\n      &:active {\n        background-color: var(--m-background-warning-pressed);\n      }\n    }\n\n    &--danger {\n      background-color: var(--m-danger);\n      color: var(--m-white);\n\n      &:hover {\n        background-color: var(--m-background-danger-hovered);\n      }\n\n      &:active {\n        background-color: var(--m-background-danger-pressed);\n      }\n    }\n\n    &--medium {\n      width: 36px;\n      height: 36px;\n    }\n\n    &:disabled {\n      pointer-events: none;\n      background-color: #f7f8f9;\n\n      * {\n        color: #adb4c0;\n      }\n    }\n  }\n}\n\n[m-data-theme=\"dark\"] {\n  .icon-button-container {\n    &__button {\n      &--default,\n      &--subtle,\n      &--primary,\n      &--primary-subtle,\n      &--warning,\n      &--danger {\n        &:hover {\n          background-color: var(--m-subtle-card-background-color);\n        }\n\n        &:active {\n          background-color: var(--m-subtle-card-background-color);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-button-container__button": `IconButton_icon-button-container__button__XT+DD`,
	"icon-button-container__button--icon": `IconButton_icon-button-container__button--icon__0c7ev`,
	"icon-button-container__button--circle": `IconButton_icon-button-container__button--circle__PxE73`,
	"icon-button-container__button--default": `IconButton_icon-button-container__button--default__sHrPv`,
	"icon-button-container__button--subtle": `IconButton_icon-button-container__button--subtle__RZ+eA`,
	"icon-button-container__button--primary": `IconButton_icon-button-container__button--primary__J6Upd`,
	"icon-button-container__button--primary-subtle": `IconButton_icon-button-container__button--primary-subtle__eN8za`,
	"icon-button-container__button--warning": `IconButton_icon-button-container__button--warning__2gcKO`,
	"icon-button-container__button--danger": `IconButton_icon-button-container__button--danger__v-yIO`,
	"icon-button-container__button--medium": `IconButton_icon-button-container__button--medium__gMj6d`
};
export default ___CSS_LOADER_EXPORT___;
